import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select",
)({
  component: () => <Outlet />,
});
